const layout = [{
        path: "/talentCard/:id",
        name: 'talentCard',
        component: () =>
            import ("@/views/layout/talentCardInfo.vue"),
        meta: {
            title: "青年人才购房券信息"
        }
    }, {
        path: "/subsidyCard/:id",
        name: 'subsidyCard',
        component: () =>
            import ("@/views/layout/subsidyCardInfo.vue"),
        meta: {
            title: "房屋征收购房卡信息"
        }
    }, {
        path: "",
        name: 'Layout',
        component: () =>
            import ("@/views/layout/layout.vue"),
        redirect: "/welcome",
        children: []
    },
    {
        path: "/welcome",
        name: "welcome",
        component: () =>
            import ("@/views/layout/welcome.vue"),
        meta: {
            title: "徐州市房地产信息网"
        }
    }, {
        path: "/Awelcome",
        name: "Awelcome",
        component: () =>
            import ("@/views/layout/Awelcome.vue"),
        meta: {
            title: "徐州市"
        }
    }, {
        path: "/home",
        name: "Home",
        component: () =>
            import ("@/views/layout/index.vue"),
        meta: {
            title: "徐州市房地产信息网"
        }
    },
    {
        path: "/transferPage",
        name: "transferPage",
        component: () =>
            import ("@/views/layout/transferPage.vue"),
        meta: {
            title: "活体实名认证确认"
        }
    },
    {
        path: "/transferFail",
        name: "transferFail",
        component: () =>
            import ("@/views/layout/transferFail.vue"),
        meta: {
            title: "活体实名认证确认"
        }
    },

    {
        path: "/projetList",
        name: "ProjetList",
        component: () =>
            import ("@/views/layout/newlist.vue"),
        meta: {
            title: "新房"
        }
    },
    {
        path: "/houseList",
        name: "HouseList",
        component: () =>
            import ("@/views/layout/oldList.vue"),
        meta: {
            title: "二手房"
        }
    },
    {
        path: "/mine",
        name: 'Mine',
        component: () =>
            import ("@/views/layout/mine.vue"),
        meta: {
            title: "个人中心"
        }
    },
    {
        path: "/login",
        name: 'Login',
        component: () =>
            import ("@/views/layout/login.vue"),
        meta: {
            title: "登录"
        }
    },
    {
        path: "/regist",
        name: 'Regist',
        component: () =>
            import ("@/views/layout/regist.vue"),
        meta: {
            title: "注册"
        }
    },
    {
        path: "/registCheck",
        name: 'RegistCheck',
        component: () =>
            import ("@/views/layout/registCheck.vue"),
        meta: {
            title: "人工审核注册"
        }
    },
    {
        path: "/message",
        name: 'Message',
        component: () =>
            import ("@/views/layout/message.vue"),
        meta: {
            title: "消息",
            isLogin: true
        }
    },
    {
        path: "/messageWx",
        name: 'messageWx',
        component: () =>
            import ("@/views/layout/messageWx.vue"),
    },
    {
        path: "/oneHouse",
        name: 'oneHouse',
        component: () =>
            import ("@/views/layout/oneHouseOnePrice.vue"),
        meta: {
            title: "未售房源一房一价"
        }
    },
    {
        path: "/jgRegist",
        name: 'JgRegist',
        component: () =>
            import ("@/views/layout/jgRegist.vue"),
        meta: {
            title: "经纪机构注册"
        }
    },
    {
        path: "/qyRegist",
        name: 'QyRegist',
        component: () =>
            import ("@/views/layout/qyRegist.vue"),
        meta: {
            title: "企业机构注册"
        }
    },
    {
        path: "/phoneChange",
        name: 'phoneChange',
        component: () =>
            import ("@/views/layout/phoneChange.vue"),
        meta: {
            title: "变更手机号"
        }
    }

];
export default layout;